import { useMatch, useResolvedPath } from "react-router-dom"
import type { PortfolioNavExpandedLink } from "../../navigation"

export interface ActiveNavLabelProps {
  link: PortfolioNavExpandedLink
}

/**
 * The active tab's label, for the range where the bar has no other text (below `md`).
 * - One per link, not a computed winner: `useMatch` is a hook and cannot run in a loop.
 * - Prefix matching can light two; the stylesheet shows the first.
 */
export default function ActiveNavLabel({ link }: ActiveNavLabelProps) {
  const resolved = useResolvedPath(link.to)
  const match = useMatch({ path: resolved.pathname, end: false })

  if (!match) { return null }
  return <span className="mobile-pathname">{link.label}</span>
}
